export const SAVE_ALL_FUEL_SUPPLIES = 'SAVE_ALL_FUEL_SUPPLIES'
export const SAVE_FUEL_SUPPLY = 'SAVE_FUEL_SUPPLY'
